import Alert from '@storeblocks/alert';
import { type FC } from 'react';
import styled from 'styled-components';

import { useTexts } from '@/hooks/useTexts';
import { media } from '@/styles/variables';

interface Props {
  contentType: 'content' | 'overview';
  fluid?: boolean;

  /**
   * To be used by Styled Components.
   */
  className?: string;
}

export const FundAvailabilityAlert: FC<Props> = ({
  contentType,
  fluid,
  className,
}) => {
  const texts = useTexts();

  switch (contentType) {
    case 'content':
      return (
        <StyledAlert
          variant="warning"
          title={texts.alert.fundAvailability.newsContent.title}
          description={texts.alert.fundAvailability.newsContent.description}
          fluid={fluid}
          className={className}
        />
      );

    case 'overview':
      return (
        <StyledAlert
          variant="warning"
          title={texts.alert.fundAvailability.overviewContent.title}
          description={texts.alert.fundAvailability.overviewContent.description}
          fluid={fluid}
          className={className}
        />
      );

    default:
      throw new Error(`Missing JSX for alert type [${contentType}].`);
  }
};

const StyledAlert = styled(Alert)`
  margin: 0;

  @media ${media.tabletAndBelow} {
    min-width: unset;
  }
`;
